<template>
  <div>
    <header>
      zine
      <router-link to="/">
        <svg @click="reload()" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 300 100" preserveAspectRatio="xMinYMax meet">
          <g id="ecos">
            <path d="M19.445,60.516c0,9.053,2.906,13.578,8.717,13.578c5.7,0,8.549-3.744,8.549-11.232v-0.838h18.775v1.006
              c0,9.275-2.347,16.289-7.041,21.039c-4.694,4.748-11.455,7.123-20.284,7.123c-8.94,0-15.869-2.682-20.786-8.045
              C2.458,77.781,0,68.896,0,56.492V34.867c0-12.07,2.319-20.898,6.957-26.486C11.595,2.793,18.496,0,27.659,0
              c9.052,0,16.065,2.85,21.038,8.549s7.46,14.473,7.46,26.318v17.602H19.445V60.516z M19.445,31.85v6.539h17.266V31.85
              c0-5.029-0.726-8.689-2.179-10.98c-1.453-2.291-3.632-3.436-6.538-3.436c-2.794,0-4.917,1.145-6.37,3.436
              C20.172,23.16,19.445,26.82,19.445,31.85z"/>
            <path d="M78.954,59.174V32.018c0-11.287,2.403-19.445,7.208-24.475C90.967,2.514,97.952,0,107.116,0
              c8.829,0,15.59,2.402,20.284,7.207c4.694,4.807,7.041,12.014,7.041,21.625v3.354h-18.775v-3.018c0-3.912-0.754-6.846-2.263-8.801
              c-1.509-1.955-3.604-2.934-6.287-2.934c-2.905,0-5.084,1.145-6.538,3.436c-1.453,2.291-2.179,5.951-2.179,10.98v27.492
              c0,5.029,0.727,8.689,2.179,10.98c1.453,2.291,3.576,3.436,6.37,3.436s4.945-0.977,6.454-2.934
              c1.508-1.955,2.263-4.945,2.263-8.969v-2.85h18.775v2.85c0,9.836-2.347,17.184-7.041,22.045s-11.455,7.291-20.284,7.291
              c-9.164,0-16.148-2.514-20.954-7.543C81.356,78.619,78.954,70.461,78.954,59.174z"/>
            <path d="M157.237,59.174V32.018c0-11.287,2.403-19.445,7.208-24.475C169.25,2.514,176.235,0,185.399,0s16.121,2.514,20.87,7.543
              s7.124,13.188,7.124,24.475v27.156c0,11.287-2.375,19.445-7.124,24.475s-11.706,7.543-20.87,7.543s-16.149-2.514-20.955-7.543
              C159.64,78.619,157.237,70.461,157.237,59.174z M193.948,59.342V31.85c0-5.029-0.727-8.689-2.18-10.98
              c-1.452-2.291-3.631-3.436-6.537-3.436c-2.794,0-4.917,1.145-6.37,3.436c-1.452,2.291-2.179,5.951-2.179,10.98v27.492
              c0,5.029,0.727,8.689,2.179,10.98c1.453,2.291,3.576,3.436,6.37,3.436c2.906,0,5.085-1.145,6.537-3.436
              C193.222,68.031,193.948,64.371,193.948,59.342z"/>
            <path d="M234.85,64.371v-1.006h18.774v1.006c0,3.352,0.838,5.951,2.515,7.795s4.023,2.766,7.041,2.766
              c2.905,0,5.112-0.811,6.621-2.43c1.509-1.621,2.263-3.996,2.263-7.125c0-2.348-0.698-4.387-2.095-6.119
              c-1.397-1.732-3.604-3.27-6.622-4.609l-10.058-4.359c-6.817-2.904-11.511-6.314-14.081-10.225c-2.57-3.912-3.855-8.83-3.855-14.752
              c0-7.264,2.514-13.299,7.543-18.105C247.925,2.402,254.519,0,262.677,0s14.751,2.402,19.78,7.207
              c5.029,4.807,7.544,11.064,7.544,18.775v1.678h-18.775v-1.006c0-3.465-0.782-6.092-2.347-7.879
              c-1.564-1.789-3.688-2.684-6.37-2.684c-2.57,0-4.61,0.727-6.118,2.18c-1.509,1.453-2.264,3.521-2.264,6.203
              c0,2.346,0.559,4.303,1.677,5.867c1.117,1.564,3.24,3.018,6.37,4.357l10.896,4.693c6.37,2.795,10.952,6.176,13.746,10.143
              s4.191,9.137,4.191,15.506c0,7.711-2.543,13.998-7.628,18.859s-11.93,7.291-20.535,7.291c-8.604,0-15.422-2.375-20.451-7.123
              C237.364,79.318,234.85,72.752,234.85,64.371z"/>
          </g>
          <defs>
            <linearGradient id="grad" x1="0%" y1="0%" x2="0%" y2="100%">>
              <stop offset="10%" stop-color="#FFF" />
              <stop offset="100%" stop-color="rgba(255,255,255,0.8)" />
           </linearGradient>
          </defs>
        </svg>
      </router-link>
      <router-link to="/sobre" style="text-decoration: none">sobre</router-link>
      <span style="margin-left:auto">
        <a href="http://facebook.com/zineecos" v-linkout>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 38" >
            <path transform="translate(2, -5)" d="M26 20v-3c0-1.3.3-2 2.4-2H31v-5h-4c-5 0-7 3.3-7 7v3h-4v5h4v15h6V25h4.4l.6-5h-5z"/>
          </svg>
        </a>
        <a href="http://feeds.feedburner.com/zinebr/ecos" v-linkout title="RSS <3">
          <svg class="rss" xmlns="http://www.w3.org/2000/svg"
               id="RSSicon"
               viewBox="0 0 8 8" width="8" height="8"
              style="fill:white">
            <g>
              <circle class="rsssymbol" cx="2" cy="6" r="1" />
              <path   class="rsssymbol" d="m 1,4 a 3,3 0 0 1 3,3 h 1 a 4,4 0 0 0 -4,-4 z" />
              <path   class="rsssymbol" d="m 1,2 a 5,5 0 0 1 5,5 h 1 a 6,6 0 0 0 -6,-6 z" />
            </g>
          </svg>
        </a>
        <a href="https://feedburner.google.com/fb/a/mailverify?uri=zinebr/ecos" v-linkout title="Receba por email!"  style="margin-top: 2px">
          <svg viewBox="0 0 21 21" width="20" height="20" style="margin: 0 0 0 1px; fill: white">
            <g>
              <polygon points="
                3, 5
                10,11
                18,5
              "/>
              <polygon points="
                3, 7
                10,13
                17,7
                17,17
                3,17
              "/>
            </g>
          </svg>
        </a>
      </span>
    </header>
    <fieldset>
      <div>
        <form @submit.prevent="searchPost()">
          <input type="text" v-model="localSearch" placeholder="busca" />
        </form>
        <button @click="searchPost()" style="border-radius: 50%">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
              <path d="M31 28h-1.59l-.55-.55c1.96-2.27 3.14-5.22 3.14-8.45 0-7.18-5.82-13-13-13s-13 5.82-13 13 5.82 13 13 13c3.23 0 6.18-1.18 8.45-3.13l.55.55v1.58l10 9.98 2.98-2.98-9.98-10zm-12 0c-4.97 0-9-4.03-9-9s4.03-9 9-9 9 4.03 9 9-4.03 9-9 9z"/>
              <path d="M0 0h48v48h-48z" fill="none"/>
          </svg>
        </button>
        <button @click="randomPost()" style="background: rgb(var(--yellow))" title="Un Coup de Dés Jamais N'Abolira Le Hasard">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"viewBox="0 0 478.439 478.439" >
            <polygon style="fill: white" points="
                195,30
                500,30
                500,310
                305,310
                305,150
                195,150
                "
              />
            <g style="fill:rgb(var(--yellow))">
              <circle cx="260" cy="95" r="40" />
              <circle cx="415" cy="95" r="40" />
              <circle cx="415" cy="245" r="40" />
            </g>
            <rect style="fill:white" x="0" y="179" rx="0" height="273" width="273" />
            <path d="M142.665,279.217c-16.12,0-29.192,13.064-29.192,29.192s13.072,29.192,29.192,29.192c16.128,0,29.2-13.064,29.2-29.192
              S158.793,279.217,142.665,279.217z"/>
            <circle style="fill:rgb(var(--yellow))" cx="140" cy="316" r="40" />
          </svg>
        </button>
      </div>
    </fieldset>
    <ul>
      <li :class="'gray '+(type =='all' && pagesCurr ? 'active':'')" @click="switchType('all')"><a>todos</a></li>
      <li :class="'red '+(type =='prosa' && pagesCurr ? 'active':'')" @click="switchType('prosa')"><a>prosa</a></li>
      <li :class="'yellow '+(type =='poesia' && pagesCurr ? 'active':'')" @click="switchType('poesia')"><a>poesia</a></li>
      <li :class="'blue '+(type =='search' && searchTerm? 'active':'invisible')" @click="switchType('search')"><a>:{{searchTerm | filterSearch}}</a></li>
    </ul>
    <v-postlist :type="type" :searchTerm="searchTerm"></v-postlist>
  </div>
</template>
<script>
import Postlist from './Postlist.vue'
import Router from '@/router'
export default {
  data() {
    return {
      type: '',
      localSearch: ''
    }
  },
  computed: {
    searchTerm() {
      return this.$store.getters.getSearchTerm;
    },
    pagesCurr() {
      if(!this.$store.getters.getPagesCurr) {
        this.type = null;
      }
      return this.$store.getters.getPagesCurr;
    }
  },
  watch: {
    'searchTerm': {
      handler(v) {
        this.localSearch = v;
        if(v.length !== 0) {
          this.type = 'search';
          this.$store.dispatch('setSearch',v);
        }
      }
    }
  },
  components: {
    'v-postlist':  Postlist
  },
  methods: {
    switchType(t) {
      const self = this;
      self.type = t;
      setTimeout(()=>{
        self.type = t;
      },200)

    },
    reload() {
      this.suprematism()
      this.type = '';
      this.localSearch = '';
      this.$store.commit('setPostsSelected',null);
      this.$store.commit('setPagesCurr',null);
    },
    randomPost() {
      this.$store.dispatch('randomPost')
    },
    searchPost() {
      this.type = 'search';
      this.$store.dispatch('setSearch',this.localSearch)
    }
  },
  filters: {
    filterSearch(str){
      let ret;
      if(str.search('autor:')>-1){
        ret = str.split('autor:')[1];
      }
      else {
        ret = str;
      }
      return ret;
    }
  }
}
</script>
<style scoped>
header {
  color: rgb(var(--red));
  font-size: 1.2em;
  border-bottom: 1px dotted rgb(var(--red));
  display: flex;
  align-items: flex-end;
  padding: 4px 0px 4px 10px;
  margin-top: 20px;
  margin-bottom: -1px;
  font-weight: bold;
}
header>a>svg {
  fill:rgb(var(--red));
  height: 30px;
  margin: 0 5px;
  overflow: visible;
}

ul {
  display: flex;
  font-size: 1.2em;
  height: 20px;
  margin: 10px 0;
}
li {
  flex: 1;
  background-repeat: no-repeat;
  font-weight: bold;
  box-sizing: border-box;
  cursor: pointer
}
li>a {
  padding: 3px;
  box-sizing: border-box;
  border-bottom: 1px solid pink;
  display: block;
  height: 100%;
  width: calc(100% - 20px);
  color: rgb(var(--dgray))
}
li.invisible {
  visibility: hidden
}
li.red {
  transition: all 200ms;
  background: linear-gradient(-45deg, rgb(var(--lgray)) 13px, rgb(var(--red)) 15px, rgb(var(--lgray)) 0px);
  border-left: 1px solid rgb(var(--red));
  border-top: 1px solid rgb(var(--red));
  margin: 0 5px;
}
li.red>a {
  border-bottom: 1px solid rgb(var(--red));
}
li.red.active {
  background: linear-gradient(-135deg, rgb(var(--lgray)) 15px, rgb(var(--red)) 5px);
}
li.yellow {
  transition: all 200ms;
  background: linear-gradient(-45deg, rgb(var(--lgray)) 13px, rgb(var(--yellow)) 15px, rgb(var(--lgray)) 0px);
  border-left: 1px solid rgb(var(--yellow));
  border-top: 1px solid rgb(var(--yellow));
}
li.yellow>a {
  border-bottom: 1px solid rgb(var(--yellow));
}
li.yellow.active {
  background: linear-gradient(-135deg, rgb(var(--lgray)) 15px, rgb(var(--yellow)) 5px);
}
li.gray {
  transition: all 200ms;
  background: linear-gradient(-45deg, rgb(var(--lgray)) 13px, rgb(var(--dgray)) 15px, rgb(var(--lgray)) 0px);
  border-left: 1px solid rgb(var(--dgray));
  border-top: 1px solid rgb(var(--dgray));
}
li.gray>a {
  border-bottom: 1px solid rgb(var(--dgray));
}
li.gray.active {
  background: linear-gradient(-135deg, rgb(var(--lgray)) 15px, rgb(var(--dgray)) 5px);
}

li.blue {
  transition: all 200ms;
  background: linear-gradient(-45deg, rgb(var(--lgray)) 13px, rgb(var(--blue)) 15px, rgb(var(--lgray)) 0px);
  border-left: 1px solid rgb(var(--blue));
  border-top: 1px solid rgb(var(--blue));
}
li.blue>a {
  border-bottom: 1px solid rgb(var(--blue));
  overflow: hidden;
  text-overflow: ellipsis;
}
li.blue.active {
  background: linear-gradient(-135deg, rgb(var(--lgray)) 15px, rgb(var(--blue)) 5px);
}

li.active {
  border-top: none;
  background-position: 20px 20px;
}
li.active>a {
  color: white;
}
fieldset>div {
  display: grid;
  grid-template-columns: 1fr 42px 40px;
  grid-gap: 2px;
  margin: 20px 0 10px 0;
  /*padding-right: 10px;*/
}
fieldset>div>span {
  display: flex;
  flex-flow: column;
  column-gap: 4px;
}
span>a {
  box-sizing: border-box;
  line-height: 0;
  height: 18px;
  width: 18px;
  display: inline-block;
  text-align: center;
  background: rgb(var(--red));
}
span>a>svg {
  height: 18px;
  width: auto;
  vertical-align: baseline;
  fill: white
}

input {
  font-family: 'DIN Next Slab Pro' !important;
  height: 30px;
  background: transparent;
  border: 0;
  width: 100%;
  border-bottom: 1px dotted #999;
  /*border: 1px solid #999;*/
  padding-left: 10px;
  box-sizing: border-box;
}
button {
  vertical-align: bottom;
  padding: 0;
  background-color: rgb(var(--dgray));
  border:0;
  border-color: rgb(var(--dgray));
  box-sizing: border-box;
  height: 40px;
  width: 40px;
  cursor: pointer;
}
svg:hover , button:hover {
  transition: filter 200ms;
  filter: brightness(110%);
}
button svg {
  margin-top: 5px;
  height: 30px;
  fill: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue